__webpack_require__.p = "/react-props-passdata/";